export abstract class BaseValidationStore {

    private _isShouldBeValidated: boolean = false;

    public setIsShouldBeValidated(isShouldBeValidated: boolean): void {
        this._isShouldBeValidated = isShouldBeValidated;
    }

    public isTrue(method: ValidationMethod): boolean {
        if (this._isShouldBeValidated === false)
            return true;

        return method();
    }

    public isFalse(method: ValidationMethod): boolean {
        if (this._isShouldBeValidated === false)
            return false;

        return method();
    }

    public abstract get isValid(): boolean;
}

export type ValidationMethod = () => boolean;